module.exports = __webpack_public_path__ + "assets/images/recurring-right.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/recurring-right.png
// module id = 1524
// module chunks = 1